import { createFileRoute } from '@tanstack/react-router';
import { PageStub } from '@/components/shared/PageStub';

export const Route = createFileRoute('/team/culture')({
  component: () => <PageStub title="Culture" description="Team culture and values" />,
});
